import { Pie } from '@ant-design/plots';
import { Divider } from 'antd';
import { useIntl } from 'react-intl';

const LmSuccessfulDeliveries = ({ ofdData, loading, plannedDeliveres }) => {
  const intl = useIntl();
  const { successful } = ofdData || {};

  const avgSuccessful =
    plannedDeliveres > 0
      ? ((successful / plannedDeliveres) * 100).toFixed(0)
      : '0';
  const data = [
    { type: 'Successful', value: Number(avgSuccessful) },
    {
      type: 'total',
      value: 100 - avgSuccessful
    }
  ];

  const config = {
    data,
    angleField: 'value',
    colorField: 'type',
    color: ['#137A84', '#ECFAFC'],
    interactions: [],
    legend: false,
    radius: 0.6,
    innerRadius: 0.7,
    label: false,
    tooltip: false,
    statistic: {
      title: {
        customHtml: () => <span className="caption-medium">{'Successful'}</span>
      },
      content: {
        customHtml: () => `<span style="display_md">${avgSuccessful}%</span>`
      }
    }
  };

  return (
    <div className="br-overview__successful-deliveries br-overview__funnel-wrapper">
      <span className="heading">
        {intl.formatMessage({ id: 'ops_control.overview.lm_successful' })}
      </span>
      <Divider />
      {loading ? <></> : <Pie {...config} />}
    </div>
  );
};

export default LmSuccessfulDeliveries;
